import { Component, inject, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Thesaurus } from '@interfaces/thesaurus.interface';
import { ThesaurusService } from '@thesaurus-service/thesaurus.service';
import { AppConfigService } from 'app/services/config/app-config.service';
import { EventsService } from 'app/services/events/events.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, of } from 'rxjs';

@Component({
    selector: 'app-thesauri',
    templateUrl: './thesauri.component.html',
    styleUrl: './thesauri.component.scss',
    standalone: false
})
export class ThesauriComponent {
  thesauri: Thesaurus[] = [];
  selectedThesaurus?: Thesaurus;
  subscription: any;
  isLoading: boolean = true;
  eventsService = inject(EventsService);
  spinnerService = inject(NgxSpinnerService);
  configService = inject(AppConfigService);

  constructor(
    private thesaurusService: ThesaurusService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    
  }

  ngOnInit(): void {
    this.subscription = this.route.queryParams.subscribe(queryParams => {
      if (queryParams['token']) {
        var selecteddatabases = '';
        if(queryParams['amp;selectedDatabases']) {
          selecteddatabases = queryParams['amp;selectedDatabases'];
        }
        var selectedthesaurus = '';
        if(queryParams['amp;thesaurus']) {
          selectedthesaurus = queryParams['amp;thesaurus'];
        }
        this.setThesauri(queryParams['token'], selecteddatabases, selectedthesaurus);
        this.eventsService.emitUpdateProductImageURL(this.route.snapshot.queryParams['amp;productImage'] || '');
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSelect(thesaurus: Thesaurus): void {
    this.selectedThesaurus = thesaurus;
  }

  setThesauri(token: string, selecteddatabases: string, selectedthesaurus: string): void {
    this.showIndexSpinner()
    this.thesaurusService.getThesauri(token, selecteddatabases, selectedthesaurus).pipe(
      catchError(error => {
        this.thesaurusService.setThesaurusServiceError(true);
        this.hideIndexSpinner();
        // Handle the error (e.g., return an empty array, rethrow a specific error)
        return of([]); // Or throw new Error('Custom error');
      })
    ).subscribe(
      thesauri => {
        this.hideIndexSpinner();
        this.thesauri = thesauri;
        if (this.thesauri.length == 1) {
          this.router.navigate(['thesaurus', this.thesauri[0].id], { queryParamsHandling: 'preserve' });
          }
        }
    );
  }

  isServiceError(): boolean {
    return this.thesaurusService.isThesaurusServiceError();
  }

  showIndexSpinner() {
    this.spinnerService.show("index-spinner");
    this.eventsService.emitDisableHelpButtonEvent(true);
  }

  hideIndexSpinner() {
    this.spinnerService.hide("index-spinner");
    this.eventsService.emitDisableHelpButtonEvent(false);
  }

  isThesaurusRefreshDescriptionsEnabled(): boolean {
    return this.configService.isThesaurusRefreshDescriptionsEnabled();
  }

}
